import {
  AuthorizationActions,
  AuthorizationTypes,
} from '@modules/authorization/store/authorization.action';

export class AuthorizationState {
  public formField: [];
  public buttons: [];
  public formTitle: string;
  public questionnaireId: string;
  public redirectUrl: string;
}

export function reducer(
  state = new AuthorizationState(),
  action: AuthorizationActions
): AuthorizationState {
  switch (action.type) {
    case AuthorizationTypes.SetQuestionnaireId:
      return {
        ...state,
        questionnaireId: action.payload,
      };
    case AuthorizationTypes.SetRedirectUrl:
      return {
        ...state,
        redirectUrl: action.payload,
      };
    default: {
      return state;
    }
  }
}
